export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: "今日速递", href: "#top" },
  { label: "热瓜榜", href: "#board" },
  { label: "速看新料", href: "#stream" },
  { label: "话题讨论", href: "#talk" },
  { label: "内容说明", href: "#trust" },
  { label: "常见问题", href: "#faq" },
];

export const hotKeywords: string[] = [
  "黑料一区新瓜",
  "今日最新瓜",
  "新料速递",
  "综艺吃瓜",
  "剧组动态",
];

export interface HeroStat {
  label: string;
  value: string;
}

export const heroStats: HeroStat[] = [
  { label: "今日上架新料", value: "128" },
  { label: "社区回帖", value: "5,214" },
  { label: "平均更新间隔", value: "15 分钟" },
  { label: "在跟话题", value: "42" },
];

export interface TickerItem {
  text: string;
  time: string;
}

export const tickerItems: TickerItem[] = [
  { text: "某综艺录制现场争执片段流出，节目组回应以正片为准", time: "12 分钟前" },
  { text: "顶流歌手新专辑预告释出，视觉风格引发两种声音", time: "28 分钟前" },
  { text: "古装剧换角传闻登上讨论榜，剧方称一切以官宣为准", time: "45 分钟前" },
  { text: "音乐节临时调整阵容，主办方公布顺延与退票方案", time: "1 小时前" },
  { text: "剧组街拍路透流出，造型团队被指审美在线", time: "1 小时前" },
  { text: "选秀节目导师阵容疑似曝光，超话讨论量一夜翻倍", time: "2 小时前" },
];

export interface BoardItem {
  rank: number;
  title: string;
  summary: string;
  tag: string;
  hot: string;
  time: string;
  comments: number;
}

export const boardItems: BoardItem[] = [
  {
    rank: 1,
    title: "某综艺录制现场疑似出现争执，节目组回应“以正片为准”",
    summary:
      "一段现场路人拍摄的短视频在社区流传，画面中两位嘉宾交流时情绪偏高。节目组当晚发出简短说明，呼吁理性讨论、不要传播未经核实的内容，成片将完整呈现前后语境。",
    tag: "综艺吃瓜",
    hot: "9.8 万",
    time: "12 分钟前",
    comments: 1286,
  },
  {
    rank: 2,
    title: "顶流歌手新专辑预告释出，视觉风格一夜之间吵成两派",
    summary:
      "十秒预告里只出现了背影与一段环境音，封面物料却出现大面积撞色设计。支持者认为风格统一、辨识度很高，另一部分听众则表示与预期差距不小，讨论仍在继续。",
    tag: "音乐现场",
    hot: "7.2 万",
    time: "28 分钟前",
    comments: 934,
  },
  {
    rank: 3,
    title: "古装剧换角传闻登上讨论榜，剧方：一切以官宣为准",
    summary:
      "有账号称原定主演因档期调整将退出，引发大量转发。剧方随后回应，项目筹备正常推进，演员阵容会在合适时间统一公布，提醒大家不要被二手信息带节奏。",
    tag: "剧组动态",
    hot: "6.5 万",
    time: "45 分钟前",
    comments: 812,
  },
  {
    rank: 4,
    title: "音乐节阵容临时微调，主办方同步给出顺延与退票方案",
    summary:
      "因场地设备检修，主办方对部分时段的演出顺序做了调整，并说明已购票观众可原票入场，无法到场的观众可按流程申请退票，具体操作入口已在公告中列出。",
    tag: "娱乐前线",
    hot: "4.1 万",
    time: "1 小时前",
    comments: 507,
  },
  {
    rank: 5,
    title: "剧组街拍路透流出，造型团队这次被夸“审美在线”",
    summary:
      "一组通勤场景的路透照被放上社区，服化道细节成为讨论重点。不少网友表示整体色调与年代设定贴合，也有观众提醒路透内容可能与正片存在差异。",
    tag: "剧组动态",
    hot: "3.6 万",
    time: "1 小时前",
    comments: 421,
  },
  {
    rank: 6,
    title: "选秀节目导师阵容疑似曝光，超话讨论量一夜翻了近三倍",
    summary:
      "一份未标注来源的名单在社群里流传，其中几位名字迅速冲上话题榜。节目方暂未回应，多位从业者提醒名单仍属传闻，最终阵容请以官方发布为准。",
    tag: "综艺吃瓜",
    hot: "2.9 万",
    time: "2 小时前",
    comments: 388,
  },
];

export interface QuickItem {
  text: string;
  time: string;
}

export const quickItems: QuickItem[] = [
  { text: "纪录片团队回应拍摄争议，称已暂停相关素材使用", time: "4 分钟前" },
  { text: "某品牌官宣新代言人，合作短片上线两小时破百万播放", time: "17 分钟前" },
  { text: "短剧演员回应改名传闻：只是艺名调整，不影响作品", time: "33 分钟前" },
  { text: "livehouse 巡演加场，主办方增开两站并同步开票", time: "52 分钟前" },
  { text: "综艺衍生访谈开播，首期嘉宾聊幕后拍摄细节", time: "1 小时前" },
];

export interface HeatThread {
  title: string;
  replies: number;
}

export const heatThreads: HeatThread[] = [
  { title: "理性讨论：路透内容和正片差距到底能有多大？", replies: 764 },
  { title: "这条预告的视觉，你们打几分？", replies: 592 },
  { title: "换角传闻为什么总是先从小号流出？", replies: 488 },
  { title: "音乐节退票流程整理，亲测可用", replies: 316 },
  { title: "整理了一下今天的热瓜时间线", replies: 274 },
];

export const categoryTabs: string[] = [
  "全部",
  "娱乐前线",
  "综艺吃瓜",
  "剧组动态",
  "音乐现场",
  "网络热点",
];

export interface StreamItem {
  title: string;
  summary: string;
  category: string;
  time: string;
  source: string;
}

export const streamItems: StreamItem[] = [
  {
    title: "某剧集官微更换置顶物料，被解读为定档前兆",
    summary:
      "主页置顶图片与简介同步更新，粉丝发现发布时间与先前传闻的档期接近。剧方暂未就具体上线时间作出说明。",
    category: "剧组动态",
    time: "6 分钟前",
    source: "官方动态",
  },
  {
    title: "综艺加更花絮放出，未播片段里的互动引二次讨论",
    summary: "加更内容补齐了正片删减的十分钟，其中一段对话成了新的解读素材，社区里已经有人做了逐帧分析。",
    category: "综艺吃瓜",
    time: "22 分钟前",
    source: "节目物料",
  },
  {
    title: "歌手巡演歌单微调，安可环节新增一首旧作",
    summary: "首站演出后歌迷反馈热烈，团队随后确认后续场次会保留这一调整，具体以每站现场为准。",
    category: "音乐现场",
    time: "38 分钟前",
    source: "现场记录",
  },
  {
    title: "品牌合作短片上线，导演在采访里聊了拍摄思路",
    summary: "短片采用一镜到底，幕后花絮同步释出，创作团队表示希望用更生活化的方式呈现产品。",
    category: "娱乐前线",
    time: "1 小时前",
    source: "品牌发布",
  },
  {
    title: "一条旧采访被翻出重新传播，当事人工作室发了说明",
    summary: "由于传播中出现了断章取义的情况，工作室贴出完整问答上下文，提醒大家看完整表达再作判断。",
    category: "网络热点",
    time: "1.5 小时前",
    source: "工作室说明",
  },
  {
    title: "剧组成员晒出杀青照，拍摄周期与预期基本一致",
    summary: "照片中场景布置与开机时基本吻合，有从业者据此推测后期制作已进入收尾阶段。",
    category: "剧组动态",
    time: "2 小时前",
    source: "成员分享",
  },
  {
    title: "线下见面会加开一场，主办方公布分批入场安排",
    summary: "为缓解人流压力，活动改为分时段入场，票务与入场规则同步更新，详情以官方公告为准。",
    category: "娱乐前线",
    time: "2.5 小时前",
    source: "活动公告",
  },
  {
    title: "某平台征集年度盘点素材，粉丝自制榜单开始流传",
    summary: "平台发起年度话题征集后，多个自制榜单在社区扩散。需要提醒的是，非官方榜单仅供参考。",
    category: "网络热点",
    time: "3 小时前",
    source: "平台活动",
  },
  {
    title: "综艺常驻阵容录制路透流出，站位变化引发猜测",
    summary: "路透只拍到部分画面，站位是否代表身份调整尚无定论，节目组一贯不回应此类细节。",
    category: "综艺吃瓜",
    time: "3.5 小时前",
    source: "社区投稿",
  },
  {
    title: "新歌上线首日口碑两极，制作人回应编曲争议",
    summary: "制作人在社交平台解释了编曲取舍的考量，表示欢迎不同听感，也希望讨论能回到作品本身。",
    category: "音乐现场",
    time: "4 小时前",
    source: "制作人回应",
  },
];

export interface TalkThread {
  title: string;
  excerpt: string;
  replies: number;
  tag: string;
  active: string;
}

export const talkThreads: TalkThread[] = [
  {
    title: "今天这几条瓜，哪些已经站稳、哪些还是存疑？",
    excerpt: "把今天被转得最多的几条放在一起对了一遍，官方回应的和纯路人拍的，可信度是两回事，大家怎么看？",
    replies: 312,
    tag: "理性吃瓜",
    active: "2 分钟前有新回复",
  },
  {
    title: "整理了一份时间线，方便后来的人补课",
    excerpt: "按小时排了一下事件顺序，标注了每条信息的来源和是否有官方回应，有补充的欢迎贴在楼下。",
    replies: 208,
    tag: "事件梳理",
    active: "9 分钟前有新回复",
  },
  {
    title: "为什么要给传闻标注来源？说点自己的理解",
    excerpt: "不是替谁说话，只是发现加了来源标注之后，被误导的概率确实会低很多，也更容易判断哪条值得跟。",
    replies: 164,
    tag: "社区共识",
    active: "24 分钟前有新回复",
  },
  {
    title: "求辨认：这条截图的发布时间对吗？",
    excerpt: "截图里的界面像是旧版本，时间和文案对不上，有没有人有更完整的上下文？",
    replies: 97,
    tag: "求证",
    active: "41 分钟前有新回复",
  },
];

export interface TalkComment {
  user: string;
  text: string;
  likes: number;
  time: string;
  badge?: string;
}

export const talkComments: TalkComment[] = [
  {
    user: "吃瓜不迷路",
    text: "看到有官方回应的就先看官方，剩下的先放一放，等第二天再看往往更清楚。",
    likes: 486,
    time: "18 分钟前",
    badge: "高赞",
  },
  {
    user: "记录员小林",
    text: "补充一下，上午那条路透原图带了拍摄时间，比转发版本早了半天，细节其实挺关键的。",
    likes: 271,
    time: "35 分钟前",
  },
  {
    user: "只看作品",
    text: "不管最后结果怎样，还是希望讨论能回到作品本身，别把没证实的当定论。",
    likes: 198,
    time: "52 分钟前",
  },
];

export interface TrustPoint {
  icon: string;
  title: string;
  desc: string;
}

export const trustPoints: TrustPoint[] = [
  {
    icon: "ri-shield-check-line",
    title: "来源标注",
    desc: "每条新料都写明来自官方公告、现场记录还是社区投稿，让你一眼分清可信度层级。",
  },
  {
    icon: "ri-links-line",
    title: "多源交叉",
    desc: "只被单一账号提及的内容会额外标注「待核实」，避免把孤证当成结论来传播。",
  },
  {
    icon: "ri-time-line",
    title: "时效跟进",
    desc: "事件有官方回应后，对应条目会更新状态，过时的传闻会被标记为「已澄清」。",
  },
  {
    icon: "ri-edit-2-line",
    title: "及时更正",
    desc: "发现有误的内容会公开更正说明，修正记录保留在条目内，不做悄悄修改。",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "黑料一区的内容都是真的吗？",
    a: "我们只负责聚合与整理，并对每条内容标注来源与核实状态。带「官方回应」标记的来自公开声明；带「待核实」标记的仍属传闻，请当作线索看待，不要直接当成结论。",
  },
  {
    q: "黑料一区新瓜一般多久更新一次？",
    a: "日常保持约 15 分钟一次的滚动更新，热门事件会加密到数分钟一条。页面上方的「新料速递」会实时同步最新条目，方便你速看新料不迷路。",
  },
  {
    q: "怎么判断一条爆料值不值得跟？",
    a: "先看来源标注，再看是否有第二方独立提及，最后看有没有官方回应。三者越齐全，可信度越高。只出现单一投稿且无人跟进的，建议先放一放。",
  },
  {
    q: "黑料一区速看里会出现个人隐私内容吗？",
    a: "不会。涉及个人隐私、联系方式、未公开身份信息的内容一律不上架，这也是我们审核时最先筛掉的一类。请大家也按同样标准投稿。",
  },
  {
    q: "我可以投稿线索吗？",
    a: "可以。点击页面上的「我要爆料」即可提交，请尽量附上时间、地点和原始出处。没有出处的线索我们会先放进待核实区，确认后再上架。",
  },
  {
    q: "内容有误怎么反馈？",
    a: "在对应话题下留言，或通过页脚的反馈入口联系编辑。经核查确有出入的条目，我们会更新状态并公开更正说明，不会直接删除记录。",
  },
];

export interface FooterColumn {
  title: string;
  links: { label: string; href: string }[];
}

export const footerColumns: FooterColumn[] = [
  {
    title: "内容分区",
    links: [
      { label: "今日速递", href: "#top" },
      { label: "热瓜榜", href: "#board" },
      { label: "速看新料", href: "#stream" },
      { label: "话题讨论", href: "#talk" },
    ],
  },
  {
    title: "关于一区",
    links: [
      { label: "内容说明", href: "#trust" },
      { label: "核实标准", href: "#trust" },
      { label: "更正记录", href: "#faq" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "参与共建",
    links: [
      { label: "我要爆料", href: "#talk" },
      { label: "社区规则", href: "#trust" },
      { label: "理性吃瓜倡议", href: "#talk" },
      { label: "反馈入口", href: "#faq" },
    ],
  },
];

export const footerTags: string[] = [
  "黑料一区",
  "黑料一区新瓜",
  "黑料一区速看",
  "黑料一区最新瓜",
  "黑料一区新料速递",
  "今日最新瓜",
  "热门爆料",
  "速看新料",
];